import { Grid, styled } from '../../base';

export const ChangePasswordWrapper = styled('div')(({ theme }) => ({
    minHeight: '100vh',
    background: theme.palette.primary.main,
    minWidth: '100vh',
    display: 'flex',
    justifyContent: 'center',
}));

export const ChangePasswordGrid = styled(Grid)(() => ({
    height: '100%',
    alignSelf: 'center',
}));
